import styled from 'styled-components';
import { DialogContent, DialogActions } from '@mui/material';

export const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px !important;
`;

export const StyledDialogActions = styled(DialogActions)`
  padding: 16px 24px !important;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const FieldLabel = styled.span`
  font-weight: 500;
  margin-bottom: 4px;
`;
